import { metricKeys } from '@pulse/metrics';
import { getMetricShortName } from '@utils/metrics';
import { CURRENT_PRODUCT_MODE, isAppModule } from '@utils/constants';

export const keys = {
  BaseLine: { key: 'BaseLine', displayName: '' },
  eicombinedMetrics: {
    key: 'eicombinedMetrics', // make sure key is same for AI
    metrics: [
      metricKeys.VideoStartFailures,
      metricKeys.VideoStartFailuresTech,
      metricKeys.VideoStartTime,
      metricKeys.ExitBeforeVideoStarts,
    ],
  },
  RebufferingRatio: {
    key: metricKeys.RebufferingRatio,
    shortName: getMetricShortName({ metricKey: metricKeys.RebufferingRatio, hasSubscript: false }),
  },
  VideoPlaybackFailures: {
    key: metricKeys.VideoPlaybackFailuresPercentage,
    shortName: getMetricShortName({
      metricKey: metricKeys.VideoPlaybackFailuresPercentage,
      hasSubscript: false,
    }),
  },
  VideoPlaybackFailuresTech: {
    key: metricKeys.VideoPlaybackFailuresTechPercentage,
    shortName: getMetricShortName({
      metricKey: metricKeys.VideoPlaybackFailuresTechPercentage,
      hasSubscript: false,
    }),
  },
  VideoStartFailures: {
    key: metricKeys.VideoStartFailuresPercentage,
    shortName: getMetricShortName({
      metricKey: metricKeys.VideoStartFailuresPercentage,
      hasSubscript: false,
    }),
  },
  VideoStartFailuresTech: {
    key: metricKeys.VideoStartFailuresTechPercentage,
    shortName: getMetricShortName({
      metricKey: metricKeys.VideoStartFailuresTechPercentage,
      hasSubscript: false,
    }),
  },
  VideoStartTime: {
    key: metricKeys.VideoStartTime,
    shortName: getMetricShortName({ metricKey: metricKeys.VideoStartTime, hasSubscript: false }),
  },
  ExitBeforeVideoStarts: {
    key: metricKeys.ExitBeforeVideoStartsPercentage,
    shortName: getMetricShortName({
      metricKey: metricKeys.ExitBeforeVideoStartsPercentage,
      hasSubscript: false,
    }),
  },
  ConcurrentPlays: {
    key: metricKeys.ConcurrentPlays,
    shortName: getMetricShortName({ metricKey: metricKeys.ConcurrentPlays, hasSubscript: false }),
  },
  ConnectionInducedRebufferingRatio: {
    key: metricKeys.ConnectionInducedRebufferingRatio,
    shortName: getMetricShortName({
      metricKey: metricKeys.ConnectionInducedRebufferingRatio,
      hasSubscript: false,
    }),
  },
  Framerate: {
    key: metricKeys.Framerate,
    shortName: getMetricShortName({ metricKey: metricKeys.Framerate, hasSubscript: false }),
  },
  Bitrate: {
    key: metricKeys.Bitrate,
    shortName: getMetricShortName({ metricKey: metricKeys.Bitrate, hasSubscript: false }),
  },
  RowKeys: { key: 'RowKeys', displayName: '' },
};

export const adKeys = {
  adCombinedMetricsBundleOne: {
    key: 'adCombinedMetricsBundleOne',
    metrics: [metricKeys.RebufferingRatio, metricKeys.Bitrate],
    displayName: 'Ad Rebuff Ratio, Avg. Bitrate',
  },
  adCombinedMetricsBundleTwo: {
    key: 'adCombinedMetricsBundleTwo',
    metrics: [metricKeys.VideoStartFailuresPercentage, metricKeys.VideoStartTime],
    displayName: 'ASF, AST',
  },
  adCombinedMetricsBundleThree: {
    key: 'adCombinedMetricsBundleThree',
    metrics: [metricKeys.AdSlateDurationPct, metricKeys.AdSlatePlaysPct],
    displayName: 'Slate Duration, Slate Plays',
  },
  RebufferingRatio: {
    key: metricKeys.RebufferingRatio,
    shortName: getMetricShortName({ metricKey: metricKeys.RebufferingRatio, hasSubscript: false }),
  },
  Bitrate: {
    key: metricKeys.Bitrate,
    shortName: getMetricShortName({ metricKey: metricKeys.Bitrate, hasSubscript: false }),
  },
  VideoStartTime: {
    key: metricKeys.VideoStartTime,
    shortName: getMetricShortName({ metricKey: metricKeys.VideoStartTime, hasSubscript: false }),
  },
  AdSlateDurationPct: {
    key: metricKeys.AdSlateDurationPct,
    shortName: getMetricShortName({
      metricKey: metricKeys.AdSlateDurationPct,
      hasSubscript: false,
    }),
  },
  AdSlatePlaysPct: {
    key: metricKeys.AdSlatePlaysPct,
    shortName: getMetricShortName({ metricKey: metricKeys.AdSlatePlaysPct, hasSubscript: false }),
  },
  VideoStartFailuresPercentage: {
    key: metricKeys.VideoStartFailuresPercentage,
    shortName: getMetricShortName({
      metricKey: metricKeys.VideoStartFailuresPercentage,
      hasSubscript: false,
    }),
  },
};

export const modes = {
  TRENDS: 'trends',
  FILTERS: 'filters',
};

export const unsavedChangesTextObj = {
  title: 'Save Changes',
  text: 'Leaving this page without saving will discard any new changes. Do you want to save these changes?',
};

const { baseUrl } = window.conviva;
export const NOC_URL = `${baseUrl}/dashboard/real-time`;

export const DEFAULT_NOC_METRIC_SORT = {
  EI: { metric: metricKeys.ConcurrentPlays, order: 'desc' },
  AI: { metric: metricKeys.Plays, order: 'desc' },
  ECO_SERVER: {},
  APP: { metric: metricKeys.AverageRequestDuration, order: 'desc' },
  ODP: { metric: '', order: '' },
};

export const DEFAULT_SORT = {
  key: DEFAULT_NOC_METRIC_SORT[CURRENT_PRODUCT_MODE].metric,
  order: DEFAULT_NOC_METRIC_SORT[CURRENT_PRODUCT_MODE].order,
};

export const DEFAULT_NOC_METRICS = {
  EI: [metricKeys.Plays, metricKeys.Attempts],
  AI: [metricKeys.Plays, metricKeys.Attempts],
  APP: [metricKeys.AppUniqueDevices],
  ODP: [],
};

export const DEFAULT_DIMENSION = {
  EI: 'OBJECT_NAME',
  AI: 'OBJECT_NAME',
  APP: 'browser_name',
  ODP: '',
};

export const AI_ALERT = isAppModule ? 'APP_AI_ALERTS' : 'AI_ALERTS';

export enum ERROR_THRESHOLD_TYPE {
  OUT_OF_RANGE = 'OUT_OF_RANGE',
  GENERAL = 'GENERAL',
  LESS_EQUAL_ZERO = 'LESS_EQUAL_ZERO',
}

export const ERROR_MSG = {
  [ERROR_THRESHOLD_TYPE.OUT_OF_RANGE]: 'Value should be between 0 and 100',
  [ERROR_THRESHOLD_TYPE.GENERAL]: 'Value must be numeric',
  [ERROR_THRESHOLD_TYPE.LESS_EQUAL_ZERO]: 'Value should be greater than 0',
};

export const percentageValidation = (v: number) => ({
  type: ERROR_THRESHOLD_TYPE.OUT_OF_RANGE,
  pass: v > 0 && v < 100,
});

export const isInstantFilter = (filter) => {
  return (filter?.fid === undefined || filter?.fid === null) && filter?.name !== 'All Traffic';
};
